customElements.whenDefined('search-form').then(() => {
  class MainSearch extends SearchForm {
    constructor() {
      super();
      this.allSearchInputs = document.querySelectorAll('input[type="search"][name="q"]');
      this.setupEventListeners();
    }

    setupEventListeners() {
      const allSearchForms = new Set(Array.from(this.allSearchInputs, (input) => input.form));
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
      allSearchForms.forEach((form) => {
        if (form !== this.input.form) form.addEventListener('reset', this.onFormReset.bind(this));
      });
      this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
    }

    onFormReset(event) {
      if (!event?.target || event.target === this.input.form) {
        super.onFormReset(event);
        this.keepInSync('', this.input);
      } else {
        event.preventDefault();
        // The originating search form owns its focus and predictive reset.
        this.keepInSync('', null);
      }
    }

    onInput(event) {
      const target = event.target;
      if (!Array.from(this.allSearchInputs).includes(target)) return;
      this.keepInSync(target.value, target);
    }

    onInputFocus() {
      const isSmallScreen = window.innerWidth < 750;
      if (isSmallScreen) {
        this.scrollIntoView({behavior: 'smooth'});
      }
    }

    keepInSync(value, target) {
      this.allSearchInputs.forEach((input) => {
        if (input !== target) {
          const changed = input.value !== value;
          input.value = value;
          input.closest('predictive-search, search-form, main-search')?.toggleResetButton?.();
          if (changed) input.closest('predictive-search')?.onInput?.();
        }
      });
    }
  }

  customElements.define('main-search', MainSearch);
});
